import * as React from "react";
const SvgMenu = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 4.00244H21V6.00244H3V4.00244ZM3 11.0024H21V13.0024H3V11.0024ZM3 18.0024H21V20.0024H3V18.0024Z" }));
export default SvgMenu;
